import { createSlice } from "@reduxjs/toolkit";

export const normalizeAccountNumber = (accountNumber: unknown) =>
  String(accountNumber ?? "").replace(/-/g, "");

// Keeps the last entry for each account number, so a re-linked account can't appear twice.
const dedupeLinkedAccounts = (accounts: any) => {
  if (!Array.isArray(accounts)) {
    return accounts;
  }
  const lastIndexByNumber = new Map<string, number>();
  accounts.forEach((account, index) =>
    lastIndexByNumber.set(normalizeAccountNumber(account?.accountNumber), index)
  );
  return accounts.filter(
    (account, index) => lastIndexByNumber.get(normalizeAccountNumber(account?.accountNumber)) === index
  );
};

const initialState = {
  contactId: "",
  accountNumber: "",
  givenNameFamilyName: {},
  linkedAccountNumbers: [],
  telephoneContact: {},
  emailContact: {},
  ndsObj: {},
  orderDetails: {},
  orderInstallationDateTime: {},
  businessAccountDetails: "",
  commercialAccApiError: false,
  usi: "",
  pin: "",
  uuid: "",
  activeAccount: true,
  inactiveAccounts: [],
  inactiveBalanceLoading: false,
  deeplinkAccNum: "",
};
const customerInfoDetailsSlice = createSlice({
  name: "customerInfoDetails",
  initialState,
  reducers: {
    customerInfoDetails: (state, action) => {
      state.accountNumber = action.payload.accountNumber;
      state.contactId = action.payload.contactId;
      state.linkedAccountNumbers = action.payload.linkedAccountNumbers;
      state.givenNameFamilyName = action.payload.givenNameFamilyName;
      state.telephoneContact = action.payload.telephoneContact;
      state.emailContact = action.payload.emailContact;
    },
    addLinkedAccounts: (state, action) => {
      state.linkedAccountNumbers = dedupeLinkedAccounts(action.payload);
    },
    switchAccountData: (state, action) => {
      state.accountNumber = action.payload.accountNumber;
      state.linkedAccountNumbers = dedupeLinkedAccounts(action.payload.linkedAccountNumbers);
    },
    setDeeplinkAccNum: (state, action) => {
      state.deeplinkAccNum = action.payload;
    },
    setPin: (state, action) => {
      state.pin = action.payload;
    },
    updateTelephoneContact: (state, action) => {
      state.telephoneContact = action.payload;
    },
    updateEmailContact: (state, action) => {
      state.emailContact = action.payload;
    },
    unlinkAccounts: (state, action) => {
      state.linkedAccountNumbers = action.payload;
    },
    setNDS: (state, action) => {
      state.ndsObj = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    setOrderInstallationDateTime: (state, action) => {
      state.orderInstallationDateTime = action.payload;
    },
    setBusinessAccountDetails: (state, action) => {
      state.businessAccountDetails = action.payload;
    },
    setCommercialAccApiError: (state, action) => {
      state.commercialAccApiError = action.payload;
    },
    setActiveAccount: (state, action) => {
      state.activeAccount = action.payload;
    },
    setInactiveAccounts: (state, action) => {
      state.inactiveAccounts = action.payload;
    },
    setInactiveBalaceLoading: (state, action) => {
      state.inactiveBalanceLoading = action.payload;
    },
  },
});

export const {
  customerInfoDetails,
  addLinkedAccounts,
  switchAccountData,
  updateTelephoneContact,
  updateEmailContact,
  unlinkAccounts,
  setNDS,
  setOrderDetails,
  setOrderInstallationDateTime,
  setBusinessAccountDetails,
  setCommercialAccApiError,
  setActiveAccount,
  setPin,
  setInactiveAccounts,
  setDeeplinkAccNum,
  setInactiveBalaceLoading,
} = customerInfoDetailsSlice.actions;
export const customerInfoDetailsReducer = customerInfoDetailsSlice.reducer;
